/**
 * It waits for a specified number of milliseconds before resolving.
 * @param {number} milliseconds - It is a number that represents the duration in milliseconds
 */
export const wait = async (milliseconds: number) => {
  return new Promise(resolve => {
    setTimeout(resolve, milliseconds);
  });
};
